<ul class="list-group rounded-0 editPersonOverflow">
    <li class="list-group-item" *ngFor="let request of requests;" (click)="toggle(request.requestGuid)">
        <div class="row p-0">
            <!-- Specific classes if use checkboxes -->
            <div class="col-12">
                <!-- Display checkbox -->
                <input id="person_{{request.requestGuid}}" class="form-check-input checkbox mt-1 col-1" type="checkbox" [checked]="request.checked">

                <!-- Display name of actor -->
                <label for="person_{{request.requestGuid}}" (click)="$event.stopPropagation();" class="fs-12 col-11">{{ request.requestName }}</label>
            </div>
        </div>
    </li>
</ul>